import { render } from "./deleteAnexo.vue?vue&type=template&id=f093625e"
import script from "./deleteAnexo.vue?vue&type=script&lang=js"
export * from "./deleteAnexo.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__